import { ModalControlled2 } from "@/ui2/molecules/Modal";
import type { Note } from "@/core/types";
import { NoteHistoryTimeline } from "@/features/cosignature/components/NoteHistoryTimeline";
import type { NoteHistoryViewAs } from "@/features/cosignature/types";
import { testLocator } from "@/lib/helpers/test-locator";

import { getTitle } from "../helpers/get-note-title";

type Props = {
  isOpen: boolean;
  note: Note | undefined;
  onClose: () => void;
  viewAs: NoteHistoryViewAs;
};

export function NoteCosignHistoryModal({ isOpen, note, onClose, viewAs }: Props) {
  const noteName = note ? getTitle(note) || note.note_type || "Note" : "Note";

  return (
    <ModalControlled2
      className="tw:min-w-200"
      isOpen={isOpen}
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
      title={`${noteName} History`}
      {...testLocator("cosignHistoryModal")}
    >
      {note && <NoteHistoryTimeline noteId={note.id} viewAs={viewAs} />}
    </ModalControlled2>
  );
}
